import { fetchLogoPreviews, requestIcons } from './new-logo'
import { getPurchases } from './purchases'

const AUTOMAGIC_SERVER_HOST = process.env.REACT_APP_AUTOMAGIC_SERVER_HOST

// New User

export const VALIDATE_CREATE_USER_FIELDS_SUCCESS = 'VALIDATE_CREATE_USER_FIELDS_SUCCESS'
export const validateCreateUserFieldsSuccess = () => {
  return {
    type: VALIDATE_CREATE_USER_FIELDS_SUCCESS
  }
}

export const VALIDATE_CREATE_USER_FIELDS_FAILURE = 'VALIDATE_CREATE_USER_FIELDS_FAILURE'
export const validateCreateUserFieldsFailure = () => {
  return {
    type: VALIDATE_CREATE_USER_FIELDS_FAILURE
  }
}

export const CREATE_USER_SUCCESS = 'CREATE_USER_SUCCESS'
export const createUserSuccess = (newUser) => {
  return {
    type: CREATE_USER_SUCCESS,
    payload: newUser
  }
}

export const CREATE_USER_FAILURE = 'CREATE_USER_FAILURE'
export const createUserFailure = (error) => {
  return {
    type: CREATE_USER_FAILURE,
    payload: error
  }
}

export const CREATE_USER = 'CREATE_USER'
const createUsr = () => {
  return {
    type: CREATE_USER
  }
}

export const createUser = (props) => {
  return (dispatch) => {
    dispatch(createUsr)

    let data = {
      name: props.name,
      email: props.email,
      password: props.password,
      language: props.language
    }

    return fetch(`${ AUTOMAGIC_SERVER_HOST }/auth/local-signup`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data)
    })
    .then(response => response.json())
    .then(json => {
      if (json.error) {
        // Fail if we got some logic error from API
        dispatch(createUserFailure(json.error))
        return Promise.reject(json.error)
      }
      if (json.token) {
        // Set the token for the first time
        localStorage.setItem('automagic_token', json.token)
        // Dispatch a complementary action because we were
        // tempting to do that in the first place (before signup)
        if (props.attemptedAction && props.userPrefs) {
          if (props.attemptedAction === 'fetchLogoPreviews') {
            // Attempting to do that while fetching logo previews on logo
            // previews page/step
            dispatch(fetchLogoPreviews(props))
          } else if (props.attemptedAction === 'getPurchases') {
            // Attempting to do that while fetching purchases on dashboard page
            dispatch(getPurchases())
          } else if (props.attemptedAction === 'requestIcons') {
            // Attempting to do that while fetching icons
            dispatch(requestIcons(props.userPrefs))
            .then(icons => {
              dispatch(fetchLogoPreviews(props))
            })
          }
        }
        dispatch(createUserSuccess(json))
        return Promise.resolve(json)
      }
      // If an error occurred while attempting to create an user
      if (!json.success && json.message) {
        dispatch(createUserFailure(json.message))
        return Promise.reject(json.message)
      }
      // Fail otherwise
      let otherError = "Not able to process signup"
      dispatch(createUserFailure(otherError))
      return Promise.reject(otherError)
    })
    .catch(error => {
      dispatch(createUserFailure(error))
      return Promise.reject(error)
    })
  }
}

export const CREATE_USER_RESET = 'CREATE_USER_RESET'
// TODO: Implement
export const SELECT_CREATED_USER = 'SELECT_CREATED_USER'
// TODO: Implement

// User Authentication by token

export const AUTHENTICATE_USER_SUCCESS = 'AUTHENTICATE_USER_SUCCESS'
export const authenticateUserSuccess = (data) => {
  return {
    type: AUTHENTICATE_USER_SUCCESS,
    payload: data
  }
}

export const AUTHENTICATE_USER_FAILURE = 'AUTHENTICATE_USER_FAILURE'
export const authenticateUserFailure = (error) => {
  return {
    type: AUTHENTICATE_USER_FAILURE,
    payload: error
  }
}

export const AUTHENTICATE_USER = 'AUTHENTICATE_USER'
const authUser = () => {
  return {
    type: AUTHENTICATE_USER
  }
}

export const authenticateUser = () => {
  return (dispatch) => {
    dispatch(authUser)

    let jwtFromStorage = localStorage.getItem('automagic_token')
    if (!jwtFromStorage) {
      dispatch(authenticateUserFailure("Token not found"))
      return Promise.reject("Token not found")
    }
    return fetch(`${ AUTOMAGIC_SERVER_HOST }/users/validate`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${jwtFromStorage}`
      }
    })
    .then(response => {
      return response.json()
    })
    .then(json => {
      if (json.error) {
        // Fail if we got some logic error from API
        localStorage.removeItem('automagic_token')
        dispatch(authenticateUserFailure(json.error))
        return Promise.reject(json.error)
      }
      if (json.success) {
        dispatch(authenticateUserSuccess(json))
        return Promise.resolve(json)
      }
      // Fail otherwise
      localStorage.removeItem('automagic_token')
      dispatch(authenticateUserFailure("Error when validating user"))
      return Promise.reject("Error when validating user")
    })
    .catch(error => {
      // Remove token from storage
      localStorage.removeItem('automagic_token')
      dispatch(authenticateUserFailure(error))
      return Promise.reject(error)
    })
  }
}

export const RESET_TOKEN = 'RESET_TOKEN'
export const resetToken = () => {
  return {
    type: RESET_TOKEN
  }
}

export const RESET_SIGNIN = 'RESET_SIGNIN'
export const resetSignin = () => {
  return {
    type: RESET_SIGNIN
  }
}

// User signin (by email/password) and logout

export const LOGOUT_USER = 'LOGOUT_USER'
export const logoutUser = () => {
  return {
    type: LOGOUT_USER
  }
}

export const SIGNIN_USER_SUCCESS = 'SIGNIN_USER_SUCCESS'
export const signinUserSuccess = (data) => {
  return {
    type: SIGNIN_USER_SUCCESS,
    payload: data
  }
}

export const SIGNIN_USER_FAILURE = 'SIGNIN_USER_FAILURE'
export const signinUserFailure = (error) => {
  return {
    type: SIGNIN_USER_FAILURE,
    payload: error
  }
}

export const SIGNIN_USER = 'SIGNIN_USER'
const signinUsr = () => {
  return {
    type: SIGNIN_USER
  }
}

export const signinUser = (props) => {
  return (dispatch) => {
    dispatch(signinUsr)

    let data = {
      email: props.email,
      password: props.password
    }

    return fetch(`${ AUTOMAGIC_SERVER_HOST }/auth/local-login`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    })
    .then(response => response.json())
    .then(json => {
      if (json.error) {
        // Fail if we got some logic error from API
        dispatch(signinUserFailure(json.error))
        return Promise.reject(json.error)
      }
      if (json.token) {
        // Set the token again, possibly it received a new token regenerated by
        // server
        localStorage.setItem('automagic_token', json.token)
        // Dispatch a complementary action because we were
        // tempting to do that in the first place (before login)
        if (props.attemptedAction && props.userPrefs) {
          if (props.attemptedAction === 'fetchLogoPreviews') {
            // Attempting to do that while fetching logo previews on logo
            // previews page/step
            dispatch(fetchLogoPreviews(props))
          } else if (props.attemptedAction === 'getPurchases') {
            // Attempting to do that while fetching purchases on dashboard page
            dispatch(getPurchases())
          } else if (props.attemptedAction === 'requestIcons') {
            // Attempting to do that while fetching icons
            dispatch(requestIcons(props.userPrefs))
            .then(icons => {
              dispatch(fetchLogoPreviews(props))
            })
          }

        }
        dispatch(signinUserSuccess(json))
        return Promise.resolve(json)
      }
      // If an error occurred while attempting to signing an user
      if (!json.success && json.message) {
        dispatch(signinUserFailure(json.message))
        return Promise.reject(json.message)
      }
      // Fail otherwise
      let otherError = "Not able to process signin"
      dispatch(signinUserFailure(otherError))
      return Promise.reject(otherError)
    })
    .catch(error => {
      dispatch(signinUserFailure(error))
      return Promise.reject(error)
    })
  }
}



// WEBPACK FOOTER //
// ./src/actions/users.js